module.exports = __webpack_public_path__ + "static/media/carrot-explainer.adf8aac0.jpg";